<template>
  <div>
    <h2 class="title">Stel uw eigen pakket in 5 stappen samen</h2>

    <postcode-check v-on="$listeners" />
  </div>
</template>

<script>
import PostcodeCheck from '../components/postcode-check'

export default {
  components: { PostcodeCheck }
}
</script>
